<template>
    <div v-intersect="onIntersect" class="map-wrapper">
        <div ref="map" :style="{height}" class="map" />
        <div v-if="isShowControls" ref="controls" class="mt-3 ml-3 d-flex align-center controls">
            <hotel-map-direction-filter
                ref="filter"
                :google="google"
                :map="map"
                :markers="markers"
                :city="city || {latitude, longitude}"
            />
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, mixins, Watch} from 'vue-facing-decorator'
    import gmapsInit from '~/utils/gmaps'
    import {HotelMapMixin} from '~src/components/hotels/mixins/hotelMapMixin.src'
    import HotelMapDirectionFilter from '@/components/hotels/snippets/HotelMapDirectionFilter.vue'

    @Component({components: {HotelMapDirectionFilter}})
    export class MapLocation extends mixins(HotelMapMixin) {
        @Prop() latitude
        @Prop() longitude
        @Prop({default: '300px'}) height
        @Prop({default: null}) city
        @Prop({default: true}) isShowControls
        @Prop({default: () => ({}), type: Object}) offer

        google = null
        map = null
        markers = []

        @Watch('coordinates', {immediate: false, deep: true})
        onPointsChange() {
            if (!this.map) return
            this.removeMarkers()
            if (this.coordinates.latitude && this.coordinates.longitude) {
                this.addMarker(this.coordinates)
                this.map.setCenter({lat: this.coordinates.latitude, lng: this.coordinates.longitude})
            }
        }

        async load() {
            try {
                this.google = await gmapsInit()
                const mapOptions = {
                    disableDefaultUI: true,
                    gestureHandling: 'greedy',
                    fullscreenControl: true,
                    zoomControl: true,
                    zoom: 2,
                    center: {
                        lat: 0,
                        lng: 0,
                    },
                }

                if (this.coordinates.latitude && this.coordinates.longitude) {
                    mapOptions.zoom = 16
                    mapOptions.center = {
                        lat: this.coordinates.latitude,
                        lng: this.coordinates.longitude,
                    }
                }

                const map = new this.google.maps.Map(this.$refs.map, mapOptions)
                if (this.$refs.controls) {
                    map.controls[this.google.maps.ControlPosition.LEFT_TOP].push(this.$refs.controls)
                }
                this.map = map
                if (this.coordinates) this.addMarker(this.coordinates)
            } catch (error) {
                console.error(error)
            }
        }

        onIntersect() {
            this.load()
        }

        removeMarkers() {
            this.markers.forEach(marker => {
                toRaw(marker).setMap(null)
            })
            this.markers = []
        }

        get coordinates() {
            if (this.offer?.coordinates?.length) {
                return {
                    latitude: this.offer.coordinates[0],
                    longitude: this.offer.coordinates[1],
                }
            }

            return {
                latitude: this.latitude,
                longitude: this.longitude,
            }
        }
    }

    export default MapLocation
</script>

<style scoped lang="scss">
    .map-wrapper {
        min-height: 300px;
        z-index: 1;
    }

    :deep(.gm-style-iw button:focus) {
        outline: 0;
    }
</style>
